export const FLAG_GETTING_USERS = 'FLAG_GETTING_USERS';
export const GET_USERS_SUCCEEDED = 'GET_USERS_SUCCEEDED';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const GET_USERS = 'GET_USERS';
